/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useDataFetchIndicator } from '..';

import vopayApi from '../../services/api.config';

type HookProps = { api: vp.Api; bearer: string };

type HookTuple = [
  response: vp.EftFundingTransactionResponse,
  fetchData: (transactionID: string) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchEFTFundTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<string>('');
  const [response, setResponse] = useState<vp.EftFundingTransactionResponse>({
    Success: false,
    ErrorMessage: '',
    FailureReason: '',
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
    TransactionDateTime: '',
    HoldReleaseDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    ScheduledTransactionID: '',
    FirstName: '',
    LastName: '',
    CompanyName: '',
    RecipientName: '',
    DOB: '',
    PhoneNumber: '',
    Email: '',
    Address1: '',
    Address2: '',
    City: '',
    Province: '',
    Country: '',
    PostalCode: '',
    FinancialInstitutionNumber: '',
    BranchTransitNumber: '',
    AccountNumber: '',
    ClientReferenceNumber: '',
    LastModified: '',
    ABARoutingNumber: '',
    IBAN: '',
    Iq11: '',
    KYCPerformed: '',
    KYCReferenceNumber: '',
    SortCode: '',
    ParentTransactionID: '',
    SubTransactions: [],
    GLCode: '',
    WireReferenceNumber: '',
    TransactionTypeCode: '',
  });

  const [shouldSendRequest, setSendRequest] = useState(false);

  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');
      const res = await api.fetchEFTFundTransaction({ TransactionID: params }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: string) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
        TransactionDateTime: '',
        HoldReleaseDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        ScheduledTransactionID: '',
        FirstName: '',
        LastName: '',
        CompanyName: '',
        RecipientName: '',
        DOB: '',
        PhoneNumber: '',
        Email: '',
        Address1: '',
        Address2: '',
        City: '',
        Province: '',
        Country: '',
        PostalCode: '',
        FinancialInstitutionNumber: '',
        BranchTransitNumber: '',
        AccountNumber: '',
        ClientReferenceNumber: '',
        LastModified: '',
        ABARoutingNumber: '',
        IBAN: '',
        Iq11: '',
        KYCPerformed: '',
        KYCReferenceNumber: '',
        SortCode: '',
        ParentTransactionID: '',
        SubTransactions: [],
        Success: false,
        ErrorMessage: '',
        FailureReason: '',
        GLCode: '',
        WireReferenceNumber: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchEFTFundTransaction);
